/* eslint-disable */
// import { MarkerClusterer } from "@googlemaps/markerclusterer";

import { setOptions, importLibrary } from "@googlemaps/js-api-loader";
import BaseModule from './BaseModule';
import type Factory from '../libs/Factory';

// document.addEventListener('touchstart', function (event) {
//     if (event.target && event.target.classList.contains('pac-item')) {
//         event.target.click();
//     }
// });

// declare global {
//     interface Window {
//     }
// }

type Dealer = Record<string, any>;

export default class DealerLocator extends BaseModule {
    dealers: Dealer[] = [];
    markers: google.maps.marker.AdvancedMarkerElement[] = [];
    markerBounds: google.maps.LatLngBounds|null;
    marker: google.maps.marker.AdvancedMarkerElement|null;
    map: google.maps.Map|null;
    searchBox: google.maps.places.Autocomplete|null;
    infoWindow: google.maps.InfoWindow|null;

    input: HTMLInputElement = this.el.querySelector("#input-postcode");
    popupLoader: HTMLDivElement = this.el.querySelector('.loader-popup');
    mapWrapper: HTMLDivElement = this.el.querySelector('.section-dealer-map');
    mapElement: HTMLDivElement = this.el.querySelector("#dealer-map");
    rowMapControl: HTMLDivElement = this.el.querySelector('.row-map-control');
    listingWrapper: HTMLDivElement = this.el.querySelector('.section-dealer-listing');
    listing: HTMLDivElement = this.el.querySelector('.dealer-location-listing');
    filterElements: NodeListOf<HTMLInputElement> = this.el.querySelectorAll('[name="filter"]');

    ukCenter = { lat: 54.8310795, lng: -3.8875549 };
    ukBounds = {
        north: 62.0,
        south: 49.0,
        west: -12.0,
        east: 6.0,
    };
    zoom = 6;

    attributesMap: Record<string, { field: string, title: string }> = {
        all: { field: "all", title: "All" },
        isEvDealer: { field: "ev_dealer", title: "EV Dealer" },
        isArcticTrucks: { field: "arctic_trucks_dealer", title: "Arctic Trucks" },
        isNewSales: { field: "new_sales", title: "New Sales" },
        isServices: { field: "service", title: "Services" },
        isParts: { field: "parts", title: "Parts" },
        isUsedCars: { field: "used_dealer", title: "Used cars" },
        isFleetServices: { field: "fleet_centre", title: "Fleet services" },
        isArbHubDealer: { field: "arb_hub_dealer", title: "ARB Hub Dealer" },
        isRaptorApplicationCentre: { field: "raptor_application_centre", title: "Raptor Application Centre" },
    };

    constructor(el: HTMLElement, factory: Factory) {
        super(el, factory, 'DealerLocator');

        this.events();
        this.init().then(()=>{
            const selected = el.querySelector<HTMLInputElement>("[name='filter']:checked");
            if(selected && selected.value !== 'all'){
                this.filterDistance();
            }
        });
    }

    async init() {
        // google maps api loader
        setOptions({
            key: this.el.dataset.mapkey,
            v: "weekly",
            libraries: ["marker", "places", "geometry"],
        });
        await Promise.all([
            importLibrary("marker"),
            importLibrary('places'),
            importLibrary("geometry"),
        ]).then(async () => {

        // MAP
        this.map = new google.maps.Map(this.mapElement, {
            center: this.ukCenter,
            // restriction: {
            //     latLngBounds: this.ukBounds,
            //     strictBounds: false,
            // },
            zoom: this.zoom,
            mapId: "DEMO_MAP_ID",
            minZoom: this.zoom,
            maxZoom: this.zoom + 3,

            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            zoomControl: true,
        });
        // BOUNDS
        this.markerBounds = new google.maps.LatLngBounds();

        // INFOWINDOW
        this.infoWindow = new google.maps.InfoWindow();

        // SEARCHBOX
        const options = {
            componentRestrictions: {
                country: 'uk'
            }
        };
        this.searchBox = new google.maps.places.Autocomplete(this.input, options);
        // this.searchBox.setFields(['address_components', 'geometry', 'name']);
        this.searchBox.addListener('place_changed', () => {
            const place = this.searchBox?.getPlace();
            if (!place || !place.geometry?.location) {
                return;
            }
            const position = new google.maps.LatLng(
                place.geometry.location.lat(),
                place.geometry.location.lng()
            );

            this.showPosition(position, true);
            this.filterDistance(position);

            this.rowMapControl.classList.add('show');
        });

        this.map.addListener("bounds_changed", () => {
            this.searchBox?.setBounds(this.map?.getBounds());
        });

        // DEALER DATA
        this.popupLoader.classList.remove('hide');
        await this.loadDealers(this.ukCenter.lat, this.ukCenter.lng);
        this.popupLoader.classList.add('hide');

        if(this.input.value){
            const search = this.input.value;
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: search }).then((result) => {
                const position = result.results[0].geometry.location;
                this.showPosition(position, true);
                this.filterDistance(position);
            });
        }
        });
    }

    initMarkers() {
        this.dealers.forEach((dealer, i) => {
            const position = new google.maps.LatLng(dealer.lat, dealer.lng);
            dealer.distance = 0;

            const pin = new google.maps.marker.PinElement({
                //@ts-ignore
                glyphColor: '#ffffff',
                background: '#e30513',
                borderColor: '#91201b',
            });
            dealer.pin = pin;

            const marker = new google.maps.marker.AdvancedMarkerElement({
                map: this.map,
                title: dealer.name,
                position,
                content: pin.element,
                gmpClickable: true,
                zIndex: 2,
            });
            marker.addListener('click', () => {
                this.infoWindow?.close();
                this.infoWindow?.setHeaderContent(dealer.name);
                this.infoWindow?.setContent(this.renderInfoWindow(dealer));
                this.infoWindow?.open(marker.map, marker);
            });
            dealer.marker = marker;
            this.markers.push(marker);
            this.markerBounds?.extend(position);

            this.listing.insertAdjacentHTML("beforeend", this.renderListItem(dealer, i));
        });

        // new MarkerClusterer({
        //     map: this.map,
        //     markers: this.markers,
        // });

        this.listing.classList.remove('hidden');
        this.rowMapControl.classList.add('show');
    }

    renderInfoWindow(dealer: Dealer){
        return `<div>
            <div class="dealer-info-window">
                <img src="" alt="">
                ${dealer.distance ? `<p class="dealer-distance"><strong>${dealer.distance.toFixed(1)} miles from your location</strong></p>` : ''}
                <p class="dealer-address">${this.formatAddress(dealer)}</p>
                <p class="dealer-contact">
                    ${dealer.phone ? `<i class="fas fa-phone text-red"></i> ${dealer.phone}<br>` : ''}
                    ${dealer.email ? `<i class="fas fa-envelope text-red"></i> ${dealer.email}` : ''}
                    ${dealer.website_url ? `<i class="fas fa-globe text-red"></i> ${dealer.website_url}` : ''}
                </p>
                <div class="dealer-service-list">
                    ${Object.entries(this.attributesMap).map(([_, attribute]) => {
                        if(!dealer[attribute.field]) return '';
                        return `<span class="badge badge-pill badge-primary">${attribute.title}</span>`;
                    }).join(" ")}
                </div>
                <a href="${dealer.dealer_link}" target="_blank" class="mt-3 btn btn-primary">VIEW DEALER</a>
            </div>
        </div>`;
    }

    renderListItem(dealer: Dealer, i: number){
        let style = '';
        if (i > 5) {
            style = 'display:none;';
        }

        return `<li style="${style}" id="location-${i}" data-dealer-id="${dealer.dealer_id}">
            <div class="dealer-location-item">
                <div class="icon-location">${i + 1}</div>
                <h3 class="dealer-name">${dealer.name}</h3>
                <div class="row">
                    <div class="col-12 col-md-11">
                        ${dealer.distance ? `<p class="dealer-distance"><strong>${dealer.distance.toFixed(1)} miles from your location</strong></p>` : ''}
                        <p class="dealer-address">${this.formatAddress(dealer)}</p>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-10">
                        <div class="btn-wrapper">
                            <a href="${dealer.dealer_link}" target="_blank" class="btn btn-primary btn-full-width btn-dealer-detail">VIEW DEALER</a>
                        </div>
                    </div>
                </div>
            </div>
        </li>`;
    }

    events(){
        this.el.querySelector('.btn-view-more').addEventListener('click', (e: Event) => {
            e.preventDefault();
            this.listingWrapper.querySelectorAll('li').forEach((li) => {
                li.classList.add('d-block');
            });
            (e.currentTarget as Element).classList.add('d-none');
        });

        this.el.querySelector('.btn-location').addEventListener('click', () => {
            navigator.geolocation.getCurrentPosition(this.browserPosition);
        });

        this.el.querySelectorAll('.btn-toggle').forEach((btn: HTMLElement) => {
            btn.addEventListener('click', (e: Event) => {
                e.preventDefault();
                const target = (e.currentTarget as HTMLElement).dataset.toggleTarget;
                this.mapWrapper.classList.add('hidden');
                this.listingWrapper.classList.add('hidden');
                this.el.querySelector(target).classList.remove('hidden');
            });
        });

        this.el.querySelectorAll('.dealer-filter-list input').forEach((filter: HTMLInputElement) => {
            filter.addEventListener('click', () => {
                this.filterDistance();
            });
        });
    }

    async loadDealers(lat: number, lng: number){
        let url = '/wp-admin/admin-ajax.php';
        let query = new URLSearchParams({ lat: lat.toString(), lng: lng.toString(), action: 'find_a_dealer' });

        return fetch(`${url}?${query.toString()}`, {
            method: 'GET',
            headers: { 'Accept': 'application/json' },
        })
        .then((json) => {
            return json.json();
        })
        .then((response) => {
            this.dealers = response;
            this.initMarkers();
        });
    }

    getSetFilters(){
        const checkedPlace = [];
        for (let i = 0; i < this.filterElements.length; i++) {
            if (this.filterElements[i].checked) {
                checkedPlace.push(this.filterElements[i].value);
            }
        }
        return checkedPlace;
    }

    showPosition(position: google.maps.LatLng, show = true){
        if(show){
            this.marker = new google.maps.marker.AdvancedMarkerElement({
                map: this.map,
                title: 'Marker',
                position,
                zIndex: 1,
            });

            this.map?.panTo(position);
        } else {
            this.map?.setCenter(position);
        }

        this.map?.setZoom(9);
        this.searchBox?.setBounds(this.map?.getBounds());
    }

    filterDistance(position?: google.maps.LatLng) {
        if(position){
            this.dealers.forEach((dealer) => {
                const dealerPosition = new google.maps.LatLng(dealer.lat, dealer.lng);
                dealer.distance = google.maps.geometry.spherical.computeDistanceBetween(
                    position,
                    dealerPosition
                ) * 0.0006213711922373339; // in miles
            });
            this.dealers.sort((a, b) => a.distance - b.distance);
        }

        const filters = this.getSetFilters();
        let count = 1;
        this.listing.innerHTML = '';
        this.dealers.forEach((dealer) => {
            const marker = dealer.marker;

            const check = filters.every((filter) => {
                if(filter === 'all') return true;
                const attribute = this.attributesMap[filter];
                return dealer[attribute.field] === true;
            });

            if(check){
                marker.setMap(this.map);
                if (position) {
                    dealer.pin.glyphText = count.toString();
                }
                this.listing.insertAdjacentHTML("beforeend", this.renderListItem(dealer, count - 1));
                count++;
            } else {
                marker.setMap(null);
            }
        });
    }

    formatAddress(dealer: Dealer, inline = false): string {
        return [[
            dealer.address_street1, dealer.address_street2, dealer.address_street3
        ].filter(Boolean).join(', '),
            dealer.address_town,
            dealer.address_postalcode
        ].filter(Boolean).join(inline ? ", " : ", <br>");
    }

    browserPosition(pos: {coords: {latitude: number, longitude: number}}): void {
        const position = new google.maps.LatLng(
            pos.coords.latitude,
            pos.coords.longitude
        );
        this.showPosition(position);
        this.filterDistance(position);
    }
}
